import { Card, CardHeader, Subtitle2Stronger } from "@fluentui/react-components";
import _ from "lodash";
import pluralize from "pluralize";
import { memo } from "react";
import { useMetadataSectionStyles } from "../styles/MetadataSection.styles";
import { RenderTagListing } from "./RenderTagListing";

type MetadataCardProps = {
  label: string;
  tags: Array<{ id: string; name: string }>;
  className: string;
};

export const MetadataSection = memo(({ label, tags, className }: MetadataCardProps) => {
  const styles = useMetadataSectionStyles();
  return (
    <Card appearance="subtle">
      <CardHeader
        header={<Subtitle2Stronger className={styles.tagsHeader}>{pluralize(_.startCase(label))}</Subtitle2Stronger>}
      />
      <RenderTagListing tags={tags} className={className} />
    </Card>
  );
});
